/**
 * API服务类型定义
 * 定义应用中可用的API服务类型
 */
/**
 * API服务类型枚举
 * 列出应用中支持的API服务
 */
export var ApiServiceType;
(function (ApiServiceType) {
    /**
     * 翻译API服务
     */
    ApiServiceType["TRANSLATION"] = "translation";
    /**
     * 为未来服务预留，目前未实现
     */
    ApiServiceType["AUTH"] = "auth";
    /**
     * 为未来服务预留，目前未实现
     */
    ApiServiceType["DATA"] = "data";
})(ApiServiceType || (ApiServiceType = {}));
//# sourceMappingURL=api-service-types.js.map